import Button from '../button/index.vue';
import { reactive, onMounted, ref, watch, computed,  } from 'vue';
import 'vue-datepicker-next/locale/zh-cn';
import 'vue-datepicker-next/locale/zh-tw';
import 'vue-datepicker-next/locale/en';
import 'vue-datepicker-next/locale/fr';
import 'vue-datepicker-next/locale/de';
import 'vue-datepicker-next/locale/ru';
import 'vue-datepicker-next/locale/it';
import 'vue-datepicker-next/locale/ja';
import 'vue-datepicker-next/locale/nl';
import 'vue-datepicker-next/locale/ko';
import 'vue-datepicker-next/locale/pl';
import 'vue-datepicker-next/locale/ro';
import 'vue-datepicker-next/locale/es';
import 'vue-datepicker-next/locale/sv';
import 'vue-datepicker-next/locale/tr';
import 'vue-datepicker-next/locale/uk';
import 'vue-datepicker-next/locale/hi';
import 'vue-datepicker-next/locale/th';
import 'vue-datepicker-next/locale/vi';
import * as moment from 'moment';
import DatePicker from 'vue-datepicker-next';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';



export default {
  components: {
    Button,
    DatePicker
  },
  props: {
    value: {
      type: Object || null   ,
    },
    defaultValue: {
      type: Object || null   ,
    },
    error: {
      type: String,
      default: '',
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    minDay: {
      type: Object || null ,
    },
    clearable: {
      type: Boolean  ,
      default: false,
      required: false, 
    },

  },
  setup(props, { emit }) {
    const dateLang = {
      ch: 'zh-cn', //zh-CN
      tw: 'zh-tw', //zh-TW
      en: 'en', //en-US
      french: 'fr', //fr-FR
      german: 'de', //de-DE
      russian: 'ru', //ru-RU
      italian: 'it', //it-IT
      japanese: 'ja', //ja-JP
      dutch: 'nl', //nl-NL
      korean: 'ko', //ko-KR
      polish: 'pl', //pl-PL
      romanian: 'ro', //ro-RO
      spanish: 'es', //es-ES
      swedish: 'sv', //sv-SE
      turkish: 'tr', //tr-TR
      ukrainian: 'uk', //uk-UA
      indonesian: 'hi', //hi-IN
      thai: 'th', //th-TH
      vietnamese: 'vi', //vi-VN
      lang: 'lang',
  
  }
    const { t } = useI18n();
    const store = useStore()
    const state = reactive({
      temp: {},
      open: false,
      time: null,
      func: () => { },
      localTime: null,
      langType: ''
    });

    


    onMounted(() => {
      state.langType = dateLang[store.state.langIsSelected]
      if (props.value) {
        state.time = props.value;
        state.temp = props.value;
      }
    })


    const privateValue = computed({
      get: () => props.value,
      set: (val) => {
        let defaultStart = moment(val).toISOString()
        state.time = defaultStart;
        state.temp = defaultStart;
      }
    });



    //picker
    const applyDate = (localEmit) => {
      // console.log('e',localEmit)
      state.func = localEmit;
      console.log(JSON.stringify(state.time))
      if (JSON.stringify(state.time) === JSON.stringify(state.temp)) {
        state.open = false
      } else {
        localEmit(state.temp)
        state.localTime = state.temp
      }
      state.temp = {}
    };
    const datePickerConfirm = () => {
      // console.log('e',e)
    };


    const closePicker = () => {
      state.temp = {}
      state.open = false

    };


    const calendarChange = (e) => {
      state.temp = e
    };

    //picker


    const notBeforeThisDay = (date) => {
      if(props.minDay){
        return date < props.minDay;
      }

    };


    const datePicker = ref();



    store.watch((state) => (state.langIsSelected ), (newType) => {
      state.langType = dateLang[newType]
    })


    watch( //
      () => state.open,
      (val) => {
        if (val) {
          if (props.value) {
            let localTemp = moment(props.value).toISOString()
            state.temp = localTemp
          }
        }
      },
    )//end: watch 




    watch(
      () => state.time,
      (val, old) => {
        if (val != old) {
          let flag = false;
          if (val != null) {
            flag = true
          }
          if (flag) {
            emit('changeDatePicker', val);
          } else {
            emit('changeDatePicker', null);
          }
        }
      },
      { deep: true }
    )//end: watch 


    watch(
      () => props.value,
      (val) => {
        state.time = val;
        state.temp = val;
      },
      { deep: true }
    )//end: watch 






    return {
      state,
      datePicker,
      applyDate,
      datePickerConfirm,
      calendarChange,
      closePicker,
      privateValue,
      t,
      notBeforeThisDay

    }
  }
}

